export default "__VITE_ASSET__lEhynu0R__"